export const getSku = '/sku/sku-by-banner-id';
export const addSku = '/sku/addSku';
export const updateSku = '/sku/';
export const deleteProductById = '/banners/delete-product-by-id/';
export const addNewSkuProduct = '/banners/add-product-by-ids';
